<template>
  <div class="the-header">
    <div class="the-logo">
      <img :src="require('@img/logo.png')">
      <span>{{ systemName }}</span>
    </div>
    <the-header-search></the-header-search>
    <the-header-area></the-header-area>
    <el-button type="primary" icon="el-icon-link" @click="toOperate('caozuo.pdf')">操作指引</el-button>
    <div style="display: inline-block;position: absolute;color:#fff;right: 30px;">经度：{{lng}} 纬度：{{lat}}</div>
  </div>
</template>

<script>
import { systemName } from '@/config/system'
import Bus from '@/api/bus'
export default {
  name: 'TheHeader',
  components: {
    TheHeaderSearch: () => import('@comp/TheHeaderSearch'),
    TheHeaderArea: () => import('@comp/TheHeaderArea')
  },
  mounted(){
    Bus.$on('data', (data) => {
        this.lat=data.latitude
        this.lng=data.longitude
      })

  },
  data () {
    return {
      systemName: systemName,
      lat:localStorage.getItem('lat'),
      lng:localStorage.getItem('lng')
    }
  },
  methods:{
    toOperate(fileName){
      const fileUrl = window.location.origin+window.location.pathname+'caozuo.pdf'
      window.open(fileUrl,'_blank')
      // const link = document.createElement('a')
      // link.href = fileUrl
      // link.setAttribute('download',fileName)
      // link.click()
      // window.open('../assets/file/caozuo.docx')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.the-header{
  width: 100%;
  height: $headerHeight;
  line-height: $headerHeight;
  padding: 0 $paddingHorizontal;
  background: $headerBgColor no-repeat center;
  background-size: cover;
  .the-logo{
    display: inline-block;
    height: 100%;
    img{
      width: 20px;
      height: 22px;
      margin-right: 8px;
      vertical-align: middle;
    }
    span{
      vertical-align: middle;
      letter-spacing: 1px;
      font-weight: bold;
      font-size: 20px;
      color: #fff;
    }
  }
}
</style>
